{
  "es": {
    "countries": {
      "ABW": "Aruba",
      "AFG": "Afganistán",
      "AFI": "Afars e Issas",
      "AGO": "Angola",
      "AIA": "Anguila",
      "ALA": "Islas Åland",
      "ALB": "Albania",
      "AND": "Andorra",
      "ANT": "Antillas Neerlandesas",
      "ARE": "Emiratos Árabes Unidos",
      "ARG": "Argentina",
      "ARM": "Armenia",
      "ASM": "Samoa Americana",
      "ATA": "Antártida",
      "ATB": "Territorio Antártico Británico",
      "ATF": "Tierras Australes y Antárticas Francesas",
      "ATG": "Antigua y Barbuda",
      "ATN": "Tierra de la Reina Maud",
      "AUS": "Australia",
      "AUT": "Austria",
      "AZE": "Azerbaiyán",
      "BDI": "Burundi",
      "BEL": "Bélgica",
      "BEN": "Benín",
      "BES": "Bonaire, San Eustaquio y Saba",
      "BFA": "Burkina Faso",
      "BGD": "Bangladés",
      "BGR": "Bulgaria",
      "BHR": "Baréin",
      "BHS": "Bahamas",
      "BIH": "Bosnia y Herzegovina",
      "BLM": "San Bartolomé",
      "BLR": "Bielorrusia",
      "BLZ": "Belice",
      "BMU": "Bermudas",
      "BOL": "Bolivia",
      "BRA": "Brasil",
      "BRB": "Barbados",
      "BRN": "Brunéi",
      "BTN": "Bután",
      "BUR": "Birmania",
      "BVT": "Isla Bouvet",
      "BWA": "Botsuana",
      "BYS": "Bielorrusia",
      "CAF": "África Central",
      "CAN": "Canadá",
      "CCK": "Islas Cocos (Keeling)",
      "CHE": "Suiza",
      "CHL": "Chile",
      "CHN": "China",
      "CIV": "Costa de Marfil",
      "CMR": "Camerún",
      "COD": "Congo",
      "COG": "Congo",
      "COK": "Islas Cook",
      "COL": "Colombia",
      "COM": "Comoras",
      "CPV": "Cabo Verde",
      "CRI": "Costa Rica",
      "CSK": "Checoslovaquia",
      "CTE": "Islas Canton y Enderbury",
      "CUB": "Cuba",
      "CUW": "Curazao",
      "CXR": "Isla de Navidad",
      "CYM": "Islas Caimán",
      "CYP": "Chipre",
      "CZE": "República Checa",
      "DDR": "Alemania Oriental",
      "DEU": "Alemania",
      "DHY": "Dahomey",
      "DJI": "Yibuti",
      "DMA": "Dominica",
      "DNK": "Dinamarca",
      "DOM": "República Dominicana",
      "DZA": "Argelia",
      "ECU": "Ecuador",
      "EGY": "Egipto",
      "ERI": "Eritrea",
      "ESH": "Sáhara Occidental",
      "ESP": "España",
      "EST": "Estonia",
      "ETH": "Etiopía",
      "FIN": "Finlandia",
      "FJI": "Fiyi",
      "FLK": "Islas Malvinas",
      "FRA": "Francia",
      "FRO": "Islas Feroe",
      "FSM": "Micronesia",
      "FXX": "Francia Metropolitana",
      "GAB": "Gabón",
      "GBR": "Reino Unido",
      "GEL": "Islas Gilbert",
      "GEO": "Georgia",
      "GGY": "Guernsey",
      "GHA": "Ghana",
      "GIB": "Gibraltar",
      "GIN": "Guinea",
      "GLP": "Guadalupe",
      "GMB": "Gambia",
      "GNB": "Guinea-Bisáu",
      "GNQ": "Guinea Ecuatorial",
      "GRC": "Grecia",
      "GRD": "Granada",
      "GRL": "Groenlandia",
      "GTM": "Guatemala",
      "GUF": "Guayana Francesa",
      "GUM": "Guam",
      "GUY": "Guyana",
      "HKG": "Hong Kong",
      "HMD": "Islas Heard y McDonald",
      "HND": "Honduras",
      "HRV": "Croacia",
      "HTI": "Haití",
      "HUN": "Hungría",
      "HVO": "Alto Volta",
      "IDN": "Indonesia",
      "IMN": "Isla de Man",
      "IND": "India",
      "IOT": "Territorio Británico del Océano Índico",
      "IRL": "Irlanda",
      "IRN": "Irán",
      "IRQ": "Irak",
      "ISL": "Islandia",
      "ISR": "Israel",
      "ITA": "Italia",
      "JAM": "Jamaica",
      "JEY": "Jersey",
      "JOR": "Jordania",
      "JPN": "Japón",
      "JTN": "Isla Johnston",
      "KAZ": "Kazajistán",
      "KEN": "Kenia",
      "KGZ": "Kirguistán",
      "KHM": "Camboya",
      "KIR": "Kiribati",
      "KNA": "San Cristóbal, Nieves y Anguila",
      "KOR": "Corea del Sur",
      "KWT": "Kuwait",
      "LAO": "Laos",
      "LBN": "Líbano",
      "LBR": "Liberia",
      "LBY": "Libia",
      "LCA": "Santa Lucía",
      "LIE": "Liechtenstein",
      "LKA": "Sri Lanka",
      "LSO": "Lesoto",
      "LTU": "Lituania",
      "LUX": "Luxemburgo",
      "LVA": "Letonia",
      "MAC": "Macao",
      "MAF": "San Martín (parte francesa)",
      "MAR": "Marruecos",
      "MCO": "Mónaco",
      "MDA": "Moldavia",
      "MDG": "Madagascar",
      "MDV": "Maldivas",
      "MEX": "México",
      "MHL": "Islas Marshall",
      "MID": "Islas Midway",
      "MKD": "Macedonia",
      "MLI": "Malí",
      "MLT": "Malta",
      "MMR": "Myanmar",
      "MNE": "Montenegro",
      "MNG": "Mongolia",
      "MNP": "Islas Marianas del Norte",
      "MOZ": "Mozambique",
      "MRT": "Mauritania",
      "MSR": "Montserrat",
      "MTQ": "Martinica",
      "MUS": "Mauricio",
      "MWI": "Malaui",
      "MYS": "Malasia",
      "MYT": "Mayotte",
      "NAM": "Namibia",
      "NCL": "Nueva Caledonia",
      "NER": "Níger",
      "NFK": "Isla Norfolk",
      "NGA": "Nigeria",
      "NHB": "Nuevas Hébridas",
      "NIC": "Nicaragua",
      "NIU": "Niue",
      "NLD": "Países Bajos",
      "NOR": "Noruega",
      "NPL": "Nepal",
      "NRU": "Nauru",
      "NTZ": "Zona Neutral",
      "NZL": "Nueva Zelanda",
      "OMN": "Omán",
      "PAK": "Pakistán",
      "PAN": "Panamá",
      "PCI": "Islas del Pacífico (Territorio en Fideicomiso)",
      "PCN": "Pitcairn",
      "PCZ": "Zona del Canal de Panamá",
      "PER": "Perú",
      "PHI": "Filipinas",
      "PHL": "Filipinas",
      "PLW": "Palaos",
      "PNG": "Papúa Nueva Guinea",
      "POL": "Polonia",
      "PRI": "Puerto Rico",
      "PRK": "Corea del Norte",
      "PRT": "Portugal",
      "PRY": "Paraguay",
      "PSE": "Territorio Palestino Ocupado",
      "PUS": "Islas Misceláneas del Pacífico de Estados Unidos",
      "PYF": "Polinesia Francesa",
      "QAT": "Qatar",
      "REU": "Reunión",
      "RHO": "Rodesia del Sur",
      "ROU": "Rumanía",
      "RUS": "Rusia",
      "RWA": "Ruanda",
      "SAU": "Arabia Saudí",
      "SCG": "Serbia y Montenegro",
      "SDN": "Sudán",
      "SEN": "Senegal",
      "SGP": "Singapur",
      "SGS": "Islas Georgias del Sur y Sandwich del Sur",
      "SHN": "Santa Elena, Ascensión y Tristán de Acuña",
      "SJM": "Svalbard y Jan Mayen",
      "SKM": "Sikkim",
      "SLB": "Islas Salomón",
      "SLE": "Sierra Leona",
      "SLV": "El Salvador",
      "SMR": "San Marino",
      "SOM": "Somalia",
      "SPM": "San Pedro y Miquelón",
      "SRB": "Serbia",
      "SSD": "Sudán del Sur",
      "STP": "Santo Tomé y Príncipe",
      "SUN": "URSS",
      "SUR": "Surinam",
      "SVK": "Eslovaquia",
      "SVN": "Eslovenia",
      "SWE": "Suecia",
      "SWZ": "Suazilandia",
      "SXM": "San Martín (parte neerlandesa)",
      "SYC": "Seychelles",
      "SYR": "Siria",
      "TCA": "Islas Turcas y Caicos",
      "TCD": "Chad",
      "TGO": "Togo",
      "THA": "Tailandia",
      "TJK": "Tayikistán",
      "TKL": "Tokelau",
      "TKM": "Turkmenistán",
      "TLS": "Timor Oriental",
      "TMP": "Timor Portugués",
      "TON": "Tonga",
      "TTO": "Trinidad y Tobago",
      "TUN": "Túnez",
      "TUR": "Turquía",
      "TUV": "Tuvalu",
      "TWN": "Taiwán, Provincia de China",
      "TZA": "Tanzania",
      "UGA": "Uganda",
      "UKR": "Ucrania",
      "UMI": "Islas Ultramarinas Menores de Estados Unidos",
      "URY": "Uruguay",
      "USA": "Estados Unidos",
      "UZB": "Uzbekistán",
      "VAT": "Ciudad del Vaticano",
      "VCT": "San Vicente y las Granadinas",
      "VDR": "Vietnam del Norte",
      "VEN": "Venezuela",
      "VGB": "Islas Vírgenes Británicas",
      "VIR": "Islas Vírgenes de los Estados Unidos",
      "VNM": "Vietnam del Sur",
      "VUT": "Vanuatu",
      "WAK": "Isla Wake",
      "WLF": "Wallis y Futuna",
      "WSM": "Samoa",
      "XXX": "Desconocido",
      "YEM": "Yemen del Norte",
      "YMD": "Yemen del Sur",
      "YUG": "Yugoslavia",
      "ZAF": "Sudáfrica",
      "ZAR": "Zaire",
      "ZMB": "Zambia",
      "ZWE": "Zimbabue"
    }
  }
}
